import { Component } from '@angular/core';
import { QPointContentContainerComponent, QPointToolbarComponent } from '@qpoint/layout';

import {
  QPointPdfRendererComponent,
} from '../../../../projects/qpoint-pdf/src/lib/qpoint-pdf-renderer/qpoint-pdf-renderer.component';
import {
  QPointPdfThumbnailComponent,
} from '../../../../projects/qpoint-pdf/src/lib/qpoint-pdf-thumbnail/q-point-pdf-thumbnail.component';

@Component({
    selector: 'app-control-gallery-pdf',
    templateUrl: './pdf.component.html',
    styleUrls: ['./pdf.component.scss'],
    imports: [QPointToolbarComponent, QPointContentContainerComponent, QPointPdfThumbnailComponent, QPointPdfRendererComponent]
})
export class ControlGalleryPdfComponent {

  constructor() { }
}
